import { render, staticRenderFns } from "./TextRegister.vue?vue&type=template&id=534aca85&"
import script from "./TextRegister.vue?vue&type=script&lang=js&"
export * from "./TextRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports